// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1271":"e1f69aab","2837":"5bcb7a2d","4084":"5bcb7a2d","4470":"210d7e2f","6063":"210d7e2f"}[chunkId] + ".chunk.css";
};